import { AfterViewChecked, Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { NgForm } from '@angular/forms';
import { LoadingController, ModalController, PopoverController } from '@ionic/angular';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  finalize,
  map,
  switchMap
} from 'rxjs/operators';
import { Location } from '@angular/common';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants } from 'src/app/utilities/constant';
import { TranslateService } from '@ngx-translate/core';
import { each } from 'chart.js/dist/helpers/helpers.core';
@Component({
  selector: 'app-machine-creation-form',
  templateUrl: './machine-creation-form.component.html',
  styleUrls: ['./machine-creation-form.component.scss'],
})
export class MachineCreationFormComponent implements OnInit, AfterViewChecked {

  @ViewChild('feature') feature: NgSelectComponent;
  @ViewChild('controlSystem') controlSystem: NgSelectComponent;
  @ViewChild('machineMode') machineMode: NgSelectComponent;
  @Input() title: any;
  @Input() service: any;
  @Input() isCustomerReadonly = false;
  @Input() isCloneMode = false;
  @Input() cloneSourceMachine: any;
  @Input() cloneCustomerId = '';
  @Input() cloneCustomerName = '';
  @Input() showCloneMachineOption = false;
  @Input() projectMachineList: any[] = [];
  formData: any;
  myFormValue: any;
  isFormSubmitted = false;
  contactList: Subject<string[]> = of([]) as Subject<string[]>;
  public contactInput$ = new Subject<string>();
  public machineCreationMode = 'add-machine';
  public selectedProjectCloneMachine: any = null;
  public projectCloneMachineLoading = false;
  public cloneCustomerList: any[] = [];
  public cloneCustomerInput$ = new Subject<string>();
  public cloneSelectedCustomer: any = null;
  public cloneCustomerLoading = false;
  private machineNameValidationInProgress = false;
  private cloneCustomerSearchTerm = '';
  private cloneCustomerIncreasedCount = 0;
  private onApplicationScrolled = new EventEmitter();
  private onMachineTypeScrolled = new EventEmitter();
  private onFeatureScrolled = new EventEmitter();
  private onControlSystemScrolled = new EventEmitter();
  getApplicationListLoading = false;
  getMachineTypeListLoading = false;
  getFeatureListLoading = false;
  getControlSystemListLoading = false;
  count = 20;
  // Following count is used to update the value of increasedCount onScroll of respective dropdown
  increasedApplicationCount = 0;
  increasedMachineTypeCount = 0;
  increasedFeaturesCount = 0;
  increasedControlSystemCount = 0;
  applicationLimitReached = false;
  machineTypeLimitReached = false;
  featureLimitReached = false;
  controlSystemLimitReached = false;
  // Following string is used to search the data in the respective dropdown
  searchApplicationTerm = '';
  searchMachineTypeTerm = '';
  searchFeaturesTerm = '';
  searchControlSystemTerm = '';
  // Following lists will be used to show the data in the form under respective dropdown
  public applicationList = [];
  public machineTypeList = [];
  public featureList = [];
  public controlSystemList = [];
  public each_service: any = null;
  selectedMachineMode: any[] = [];
  constructor(
    private elementRef: ElementRef,
    public backendService: BackendCallService,
    private modalCtrl: ModalController,
    private router: Router,
    private sharedValue: ShareValuesService,
    public loading: LoadingController,
    private _location: Location,
    private popoverController:  PopoverController,
    private toastService: ToastService,
    public translate: TranslateService,
  ) {
  }

  ngOnInit() {
    this.sharedValue.getMachineModes();
    this.subscribeApplicationScroll();
    this.subscribeMachineTypeScroll();
    this.subscribeFeaturesScroll();
    this.subscribeControlSystemScroll();
    this.onApplicationScrolled.emit();
    this.onMachineTypeScrolled.emit();
    this.onFeatureScrolled.emit();
    this.onControlSystemScrolled.emit();
    this.contactList = this.contactInput$.pipe(
      debounceTime(600),
      distinctUntilChanged(),
      switchMap((inp: string) => {
        this.formData.customerLoading = true;
        let obs: Observable<Object>;
        if (inp) {
          return this.backendService.searchServiceCustomerName(inp).pipe(
            map((res: any) => res.value),
            catchError((err) => []),
            finalize(() => {
              this.formData.customerLoading = false;
            })
          );
        } else {
          return of([]).pipe(
            finalize(() => {
              this.formData.customerLoading = false;
            })
          );
        }
      })
    ) as Subject<string[]>;
    this.subscribeCloneCustomerSearch();
  }

  ngAfterViewChecked(): void {
    this.ensureNgSelectKeyboardAccessibility();
  }

  private ensureNgSelectKeyboardAccessibility(): void {
    const host = this.elementRef?.nativeElement as HTMLElement | null;
    if (!host) {
      return;
    }

    const allSelects = host.querySelectorAll<HTMLElement>('ng-select');
    allSelects.forEach((select) => {
      const clearWrapper = select.querySelector<HTMLElement>('.ng-clear-wrapper');
      if (clearWrapper) {
        const clearIcon = clearWrapper.querySelector<HTMLElement>('.ng-clear');
        if (clearIcon) {
          clearWrapper.tabIndex = -1;
          clearWrapper.removeAttribute('role');
          clearWrapper.removeAttribute('aria-label');

          clearIcon.tabIndex = 0;
          clearIcon.setAttribute('role', 'button');
          clearIcon.setAttribute('aria-label', this.translate.instant('Clear selection'));

          if (clearIcon.getAttribute('data-keyboard-wired') !== 'true') {
            clearIcon.addEventListener('keydown', (event: KeyboardEvent) => {
              if (event.key !== 'Enter') {
                return;
              }

              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
              const field = select.getAttribute('data-field');
              if (field) {
                this.clearNgSelectField(field);
                return;
              }

              this.triggerNgSelectClear(clearIcon);
            }, true);

            clearIcon.setAttribute('data-keyboard-wired', 'true');
          }
        } else if (clearWrapper.getAttribute('data-keyboard-wired') !== 'true') {
          clearWrapper.tabIndex = 0;
          clearWrapper.setAttribute('role', 'button');
          clearWrapper.setAttribute('aria-label', this.translate.instant('Clear selection'));

          clearWrapper.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key !== 'Enter') {
              return;
            }

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            const field = select.getAttribute('data-field');
            if (field) {
              this.clearNgSelectField(field);
              return;
            }

            this.triggerNgSelectClear(clearWrapper);
          }, true);

          clearWrapper.setAttribute('data-keyboard-wired', 'true');
        }
      }

      const valueIcons = select.querySelectorAll<HTMLElement>('.ng-value-icon');
      valueIcons.forEach((icon) => {
        icon.tabIndex = 0;
        icon.setAttribute('role', 'button');
        icon.setAttribute('aria-label', this.translate.instant('Remove selected value'));

        if (icon.getAttribute('data-keyboard-wired') === 'true') {
          return;
        }

        icon.addEventListener('keydown', (event: KeyboardEvent) => {
          if (event.key !== 'Enter') {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          this.triggerNgSelectAction(icon);
        }, true);

        icon.setAttribute('data-keyboard-wired', 'true');
      });
    });
  }

  private triggerNgSelectAction(target: HTMLElement): void {
    target.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
    target.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
    target.click();
  }

  private triggerNgSelectClear(clearTarget: HTMLElement): void {
    clearTarget.click();
    clearTarget.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));
  }

  private clearNgSelectField(field: string): void {
    switch (field) {
      case 'machineMode':
        this.selectedMachineMode = [];
        break;
      case 'customerName':
        this.formData.customerName = '';
        this.formData.customerId = '';
        this.formData.industrySegment = '';
        break;
      case 'machineType':
        this.formData.machineType = '';
        break;
      case 'application':
        this.formData.application = '';
        break;
      case 'controlSystem':
        this.formData.controlSystem = [];
        break;
      case 'features':
        this.formData.features = [];
        break;
      default:
        break;
    }
  }

  ionViewWillEnter() {
    if (this.service) {
      this.each_service = this.service;
    } else {
      const eachService = sessionStorage.getItem('each_service');
      this.each_service = JSON.parse(eachService);
    }
    console.log(this.each_service,' this.each_service from storage');

    this.formData = {
      machine_name: '',
      machine_description: '',
      manufacturer: '',
      model: '',
      serial_number: '',
      asset_id: '',
      customerId: '',
      application: '',
      machineType: '',
      industrySegment: '',
      features: [],
      controlSystem: [],
      machineModes: [],
      customerLoading: false,
      customerName: ''
    };
    if (this.each_service && (this.each_service.customer_id || this.each_service.customer_Id)) {
      this.formData.customerId = this.each_service.customer_id || this.each_service.customer_Id;
      this.formData.customerName = this.each_service.customer_name || this.each_service.customer_Name;
      this.formData.industrySegment = this.each_service.industryCode;
    }
    if (this.isCloneMode) {
      this.applyCloneDefaults();
      if (!this.isCustomerReadonly) {
        this.searchCloneCustomers('');
      }
    }
  }

  public get isProjectAddCloneMode(): boolean {
    return this.showCloneMachineOption && this.machineCreationMode === 'clone-machine';
  }

  public searchProjectMachine = (searchText: string, machine: any): boolean => {
    const normalizedSearchText = (searchText || '').toLowerCase();
    const searchableValues = [
      this.getProjectMachineName(machine),
      machine?.global_Id,
      machine?.global_id,
      machine?.machine_Id,
      machine?.Machine_Id,
      machine?.id
    ];
    return searchableValues.some(value => String(value || '').toLowerCase().includes(normalizedSearchText));
  };

  public onMachineCreationModeChange(event: any): void {
    this.machineCreationMode = event?.detail?.value || this.machineCreationMode;
    this.isFormSubmitted = false;
    this.resetProjectAddMachineForm();
  }

  public onProjectCloneMachineChange(machine: any): void {
    this.selectedProjectCloneMachine = machine || null;
    this.resetProjectClonePopulatedFields();
    if (!machine) {
      return;
    }

    this.formData.machine_name = `${this.getProjectMachineName(machine)}_copy`;
    const machineId = this.getProjectMachineId(machine);
    if (!machineId) {
      this.populateProjectCloneMachineFields(machine);
      return;
    }

    this.projectCloneMachineLoading = true;
    this.backendService.getMachinesAttributesData(machineId).pipe(
      catchError(() => of(null)),
      finalize(() => {
        this.projectCloneMachineLoading = false;
      })
    ).subscribe((attributeResult: any) => {
      this.populateProjectCloneMachineFields(machine, attributeResult?.value);
    });
  }

  public getProjectMachineName(machine: any): string {
    return machine?.machine_Name
      || machine?.Machine_Name
      || machine?.machine_name
      || machine?.name
      || '';
  }

  public getSelectedOptionsTooltip(selectedValues: any[], options: any[], labelKey: string): string | null {
    if (!Array.isArray(selectedValues) || !selectedValues.length) {
      return null;
    }

    const selectedLabels = selectedValues.map((selectedValue) => {
      if (selectedValue && typeof selectedValue === 'object') {
        return selectedValue[labelKey] || selectedValue.name || '';
      }

      const selectedOption = (options || []).find(option => String(this.getOptionId(option)) === String(selectedValue));
      return selectedOption?.[labelKey] || String(selectedValue || '');
    }).filter(Boolean);

    return selectedLabels.length ? selectedLabels.join('\n') : null;
  }

  private getProjectMachineId(machine: any): string {
    return machine?.machine_Id
      || machine?.Machine_Id
      || machine?.id
      || '';
  }

  private resetProjectAddMachineForm(): void {
    this.selectedProjectCloneMachine = null;
    this.resetProjectClonePopulatedFields();
    this.formData.machine_name = '';
    if (this.each_service && (this.each_service.customer_id || this.each_service.customer_Id)) {
      this.formData.customerId = this.each_service.customer_id || this.each_service.customer_Id;
      this.formData.customerName = this.each_service.customer_name || this.each_service.customer_Name;
      this.formData.industrySegment = this.each_service.industryCode;
    }
  }

  private resetProjectClonePopulatedFields(): void {
    this.selectedMachineMode = [];
    this.formData.application = '';
    this.formData.machineType = '';
    this.formData.features = [];
    this.formData.controlSystem = [];
  }

  private populateProjectCloneMachineFields(machine: any, attributesData?: any): void {
    const machineMetaData = attributesData?.machineMetaData || machine?.machineMetaData || machine?.masterMachine?.machineMetaData || {};
    this.selectedMachineMode = this.getSelectedMachineModeObjects(attributesData?.machineModes || machine?.machineModes || []);
    this.formData.customerId = attributesData?.customer_Id || machine?.customer_Id || machine?.customer_id || this.formData.customerId;
    this.formData.customerName = attributesData?.customer_Name || machine?.customer_Name || machine?.customer_name || this.formData.customerName;

    const application = machineMetaData?.application || attributesData?.application || machine?.application;
    this.formData.application = this.getOptionId(application);
    this.applicationList = this.ensureOptionInList(this.applicationList, this.formData.application, this.getOptionLabel(application, ['application', 'name']), 'application');

    const machineType = machineMetaData?.machineType || attributesData?.machineType || machine?.masterMachine || machine;
    this.formData.machineType = this.getOptionId(machineType) || machine?.masterMachine_Id || '';
    this.machineTypeList = this.ensureOptionInList(this.machineTypeList, this.formData.machineType, this.getOptionLabel(machineType, ['machine_type', 'machineType', 'machine_Type', 'Machine_Type', 'name']) || machine?.machine_Type, 'machine_type');

    const features = this.toArray(machineMetaData?.specificFeature || attributesData?.specificFeature || machine?.specificFeature);
    this.featureList = features.reduce((list, feature) => this.ensureOptionInList(list, this.getOptionId(feature), this.getOptionLabel(feature, ['specific_feature', 'specificFeature', 'name']), 'specific_feature'), [...this.featureList]);
    this.formData.features = features.map(feature => this.getOptionId(feature)).filter(Boolean);

    const controlSystems = this.toArray(machineMetaData?.controlSystem || attributesData?.controlSystem || machine?.controlSystem);
    this.controlSystemList = controlSystems.reduce((list, controlSystem) => this.ensureOptionInList(list, this.getOptionId(controlSystem), this.getOptionLabel(controlSystem, ['control_system', 'controlSystem', 'name']), 'control_system'), [...this.controlSystemList]);
    this.formData.controlSystem = controlSystems.map(controlSystem => this.getOptionId(controlSystem)).filter(Boolean);
  }

  private getSelectedMachineModeObjects(machineModes: any[]): any[] {
    return this.toArray(machineModes).map(mode => {
      const modeId = this.getOptionId(mode);
      return this.sharedValue?.machineModeList?.find(machineMode => String(machineMode.id) === String(modeId)) || mode;
    }).filter(Boolean);
  }

  private getOptionId(option: any): any {
    if (option === null || option === undefined) {
      return '';
    }
    if (typeof option !== 'object') {
      return option;
    }
    return option.id || option.Id || option.applicationId || option.machineTypeId || option.specificFeatureId || option.controlSystemId || '';
  }

  private getOptionLabel(option: any, labelKeys: string[]): string {
    if (!option || typeof option !== 'object') {
      return '';
    }
    const matchedKey = labelKeys.find(labelKey => option[labelKey]);
    return matchedKey ? option[matchedKey] : '';
  }

  private ensureOptionInList(list: any[], id: any, label: string, labelKey: string): any[] {
    if (!id || !label || list.some(item => String(item.id) === String(id))) {
      return list;
    }
    return [{ id, [labelKey]: label }, ...list];
  }

  private toArray(value: any): any[] {
    return Array.isArray(value) ? value : value ? [value] : [];
  }

  ngOnChanges() {
    if (this.formData && this.isCloneMode) {
      this.applyCloneDefaults();
    }
  }

  private applyCloneDefaults(): void {
    this.formData.machine_name = this.formData.machine_name || this.getCloneSourceMachineName();
    this.formData.customerId = this.cloneCustomerId || this.getCloneSourceCustomerId();
    this.formData.customerName = this.cloneCustomerName || this.getCloneSourceCustomerName();
    this.cloneSelectedCustomer = this.createCloneCustomerOption(this.formData.customerId, this.formData.customerName);
    this.ensureCloneSelectedCustomerInList();
  }

  private getCloneSourceMachineName(): string {
    const sourceMachineName = this.cloneSourceMachine?.machine_Name
      || this.cloneSourceMachine?.Machine_Name
      || this.cloneSourceMachine?.machine_name
      || this.cloneSourceMachine?.name
      || '';
    return sourceMachineName ? `${sourceMachineName}_copy` : '';
  }

  private getCloneSourceCustomerId(): string {
    return this.cloneSourceMachine?.customer_Id
      || this.cloneSourceMachine?.Customer_Id
      || this.cloneSourceMachine?.customer_id
      || this.cloneSourceMachine?.customerId
      || this.cloneSourceMachine?.CustomerId
      || '';
  }

  private getCloneSourceCustomerName(): string {
    return this.cloneSourceMachine?.customer_Name
      || this.cloneSourceMachine?.Customer_Name
      || this.cloneSourceMachine?.customer_name
      || this.cloneSourceMachine?.customerName
      || this.cloneSourceMachine?.CustomerName
      || '';
  }

  private getCloneSourceMachineId(): string {
    return this.cloneSourceMachine?.id
      || this.cloneSourceMachine?.machine_Id
      || this.cloneSourceMachine?.Machine_Id
      || '';
  }

  private createCloneCustomerOption(id: string, customerName: string): any {
    if (!id && !customerName) {
      return null;
    }
    const displayName = customerName || id;
    return {
      id,
      customer_name: displayName,
      name: displayName
    };
  }

  private normalizeCloneCustomer(customer: any): any {
    if (!customer) {
      return customer;
    }

    const id = this.getCloneCustomerId(customer);
    const customerName = this.getCloneCustomerName(customer);
    return {
      ...customer,
      id,
      customer_name: customerName,
      name: customerName
    };
  }

  private ensureCloneSelectedCustomerInList(): void {
    // Keep search results backend-driven; ng-select retains the selected model separately.
    if (this.cloneCustomerSearchTerm || !this.cloneSelectedCustomer?.id) {
      return;
    }
    const currentCustomer = this.cloneCustomerList.find(customer => String(this.getCloneCustomerId(customer)) === String(this.cloneSelectedCustomer.id));
    if (!currentCustomer) {
      this.cloneCustomerList = [this.cloneSelectedCustomer, ...this.cloneCustomerList];
      return;
    }

    const normalizedCustomer = this.normalizeCloneCustomer(currentCustomer);
    this.cloneSelectedCustomer = normalizedCustomer;
    this.formData.customerId = normalizedCustomer.id;
    this.formData.customerName = normalizedCustomer.customer_name;
  }

  private subscribeCloneCustomerSearch(): void {
    this.cloneCustomerInput$.pipe(
      debounceTime(600),
      distinctUntilChanged(),
      switchMap((searchTerm: string) => {
        this.cloneCustomerSearchTerm = searchTerm || '';
        this.cloneCustomerIncreasedCount = 0;
        this.cloneCustomerLoading = true;
        return this.backendService.searchMachineCustomers({
          cloning_from_project: false,
          customer_id: '',
          customer_name: this.cloneCustomerSearchTerm,
          count: this.count,
          increasedCount: 0
        }).pipe(
          catchError(() => of({ response: [], value: [] })),
          finalize(() => {
            this.cloneCustomerLoading = false;
          })
        );
      })
    ).subscribe((response: any) => {
      this.cloneCustomerList = (response?.response || response?.value || []).map(customer => this.normalizeCloneCustomer(customer));
      this.ensureCloneSelectedCustomerInList();
    });
  }

  private searchCloneCustomers(searchTerm: string): void {
    this.cloneCustomerInput$.next(searchTerm || '');
  }

  public fetchMoreCloneCustomers(): void {
    if (this.cloneCustomerLoading) {
      return;
    }
    this.cloneCustomerLoading = true;
    this.cloneCustomerIncreasedCount += this.count;
    this.backendService.searchMachineCustomers({
      cloning_from_project: false,
      customer_id: '',
      customer_name: this.cloneCustomerSearchTerm,
      count: this.count,
      increasedCount: this.cloneCustomerIncreasedCount
    }).pipe(
      catchError(() => of({ response: [], value: [] })),
      finalize(() => {
        this.cloneCustomerLoading = false;
      })
    ).subscribe((response: any) => {
      const nextCustomers = (response?.response || response?.value || []).map(customer => this.normalizeCloneCustomer(customer));
      this.cloneCustomerList = [...this.cloneCustomerList, ...nextCustomers];
      this.ensureCloneSelectedCustomerInList();
    });
  }

  public compareCloneCustomers = (left: any, right: any): boolean => {
    return left && right ? String(this.getCloneCustomerId(left)) === String(this.getCloneCustomerId(right)) : left === right;
  };

  public onCloneCustomerChange(customer: any): void {
    this.cloneSelectedCustomer = this.normalizeCloneCustomer(customer) || null;
    this.formData.customerId = this.getCloneCustomerId(this.cloneSelectedCustomer);
    this.formData.customerName = this.getCloneCustomerName(this.cloneSelectedCustomer);
  }

  public clearCloneCustomer(): void {
    this.cloneSelectedCustomer = null;
    this.formData.customerId = '';
    this.formData.customerName = '';
    this.searchCloneCustomers('');
  }

  private getCloneCustomerId(customer: any): string {
    return customer?.id
      || customer?.customer_id
      || customer?.customer_Id
      || customer?.Customer_Id
      || customer?.customerID
      || customer?.customerId
      || customer?.CustomerId
      || customer?.company_Id
      || customer?.company_id
      || customer?.companyId
      || customer?.value
      || '';
  }

  private getCloneCustomerName(customer: any): string {
    return customer?.customer_name
      || customer?.customer_Name
      || customer?.Customer_Name
      || customer?.customerName
      || customer?.CustomerName
      || customer?.company_Name
      || customer?.company_name
      || customer?.companyName
      || customer?.label
      || customer?.name
      || '';
  }

  // Method to display the data under application dropdown
  public subscribeApplicationScroll() {
    this.onApplicationScrolled.pipe(debounceTime(100), switchMap((res) => {
      const payload =
      {
        search: this.searchApplicationTerm == '' ? ' ' : this.searchApplicationTerm,
        count: this.count,
        increasedCount: this.increasedApplicationCount,
      };
      return this.backendService.getApplicationData(payload);
    })).subscribe(
      (data: any) => {
        if (data?.value && data?.value?.length) {
          this.increasedApplicationCount = this.count;
          if (this.searchApplicationTerm !== '') {this.increasedApplicationCount = this.increasedApplicationCount + this.count;}
          if (this.applicationList.length > 1) {
            if (data.value.length !== 0) {
              this.applicationList = this.mergeAndSortUniqueItem(this.applicationList, data.value, "application");
            } else {
              this.increasedApplicationCount = 0;
              this.applicationLimitReached = data.value.length !== this.count;
              this.toastService.presentToast(this.translate.instant('no_application_records_available'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }
          } else {
            this.increasedApplicationCount = 0;
            if (data.value.length !== 0) {
              this.applicationList = this.mergeAndSortUniqueItem(this.applicationList, data.value, "application");

            } else {
              this.increasedApplicationCount = 0;
              this.applicationLimitReached = data.value.length !== this.count;
              this.toastService.presentToast(this.translate.instant('no_application_records_available'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }
          }
          this.increasedApplicationCount = this.increasedApplicationCount + this.count;
        }
        setTimeout(() => {
        }, 500);
      }, err => {
      }
    );
  }

  public mergeAndSortUniqueItem<T>(existingList: T[], newData: T[], key: keyof T): T[] {
    return [
      ...new Map(
        [...existingList, ...newData].map(item => [String(item[key]).toLowerCase(), item]) // Case-insensitive uniqueness
      ).values()
    ].sort((a, b) => String(a[key]).localeCompare(String(b[key])));
  }

  public setApplication(id) {
    this.formData.application = id;
  }

  fetchMoreApplication() {
    this.onApplicationScrolled.emit();
  }

  // Method to display the data under Machine Type dropdown
  public subscribeMachineTypeScroll() {
    this.onMachineTypeScrolled.pipe(debounceTime(100), switchMap((res) => {
      const payload =
      {
        search: this.searchMachineTypeTerm == '' ? ' ' : this.searchMachineTypeTerm,
        count: this.count,
        increasedCount: this.increasedMachineTypeCount,
      };
      return this.backendService.getMachineTypeData(payload);
    })).subscribe(
      (data: any) => {
        if (data?.value && data?.value?.length) {
          this.increasedMachineTypeCount = this.count;
          if (this.searchMachineTypeTerm !== '') {this.increasedMachineTypeCount = this.increasedMachineTypeCount + this.count;}
          if (this.machineTypeList.length > 1) {
            if (data.value.length !== 0) {
              this.machineTypeList = this.mergeAndSortUniqueItem(this.machineTypeList, data.value, "machine_type");
            } else {
              this.increasedMachineTypeCount = 0;
              this.machineTypeLimitReached = data.value.length !== this.count;
              this.toastService.presentToast(this.translate.instant('no_machine_type_records_available'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }
          } else {
            this.increasedMachineTypeCount = 0;
            if (data.value.length !== 0) {
              this.machineTypeList = this.mergeAndSortUniqueItem(this.machineTypeList, data.value, "machine_type");
            } else {
              this.increasedMachineTypeCount = 0;
              this.machineTypeLimitReached = data.value.length !== this.count;
              this.toastService.presentToast(this.translate.instant('no_machine_type_records_available'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }
          }
          this.increasedMachineTypeCount = this.increasedMachineTypeCount + this.count;
        }
        setTimeout(() => {
        }, 500);
      }, err => {
      }
    );
  }

  setMachineType(id) {
    this.formData.machineType = id;
  }

  fetchMoreMachineType() {
    this.onMachineTypeScrolled.emit();
  }

  // Method to display the data under Specific Features dropdown
  public subscribeFeaturesScroll() {
    this.onFeatureScrolled.pipe(debounceTime(100), switchMap((res) => {
      const payload =
      {
        search: this.searchFeaturesTerm == '' ? ' ' : this.searchFeaturesTerm,
        count: this.count,
        increasedCount: this.increasedFeaturesCount,
      };
      return this.backendService.getFeaturesData(payload);
    })).subscribe(
      (data: any) => {
        if (data?.value && data?.value?.length) {
          this.increasedFeaturesCount = this.count;
          if (this.searchFeaturesTerm !== '') {this.increasedFeaturesCount = this.increasedFeaturesCount + this.count;}
          if (this.featureList.length > 1) {
            if (data.value.length !== 0) {
              this.featureList = this.mergeAndSortUniqueItem(this.featureList, data.value, "specific_feature");
            } else {
              this.increasedFeaturesCount = 0;
              this.featureLimitReached = data.value.length !== this.count;
              this.toastService.presentToast(this.translate.instant('no_feature_records_available'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }
          } else {
            this.increasedFeaturesCount = 0;
            if (data.value.length !== 0) {
              this.featureList = this.mergeAndSortUniqueItem(this.featureList, data.value, "specific_feature");
            } else {
              this.increasedFeaturesCount = 0;
              this.featureLimitReached = data.value.length !== this.count;
              this.toastService.presentToast(this.translate.instant('no_feature_records_available'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }
          }
          this.increasedFeaturesCount = this.increasedFeaturesCount + this.count;
        }
        setTimeout(() => {
        }, 500);
      }, err => {
      }
    );
  }

  fetchMoreFeature() {
    this.onFeatureScrolled.emit();
  }

  setFeature(selectedItems) {
    if (selectedItems && selectedItems.length) {
      this.formData.features = selectedItems.map(item => 
        typeof item === 'object' ? item.id : item
      );
    } else {
      this.formData.features = [];
    }
  }

  removeFeatureFocus(ev) {
    const isNotDefined = this.featureList.some(ele => ele.id == ev && ele.specific_feature == 'Not Defined');
    if (isNotDefined) {this.feature.blur();}
  }

  removeControlSystemFocus(ev) {
    const isNotDefined = this.controlSystemList.some(ele => ele.id == ev && ele.control_system == 'Not Defined');
    if (isNotDefined) {this.controlSystem.blur();}
  }

  removeMachineModeFocus(ev) {
    const isNotDefined = this.sharedValue.machineModeList.some(ele => ele.id == ev && ele.name == 'Not Defined');
    if (isNotDefined) {this.machineMode.blur();}
  }

  // Method to display the data under control system dropdown
  public subscribeControlSystemScroll() {
    this.onControlSystemScrolled.pipe(debounceTime(100), switchMap((res) => {
      const payload =
      {
        search: this.searchControlSystemTerm == '' ? ' ' : this.searchControlSystemTerm,
        count: this.count,
        increasedCount: this.increasedControlSystemCount,
      };
      return this.backendService.getControlSystemData(payload);
    })).subscribe(
      (data: any) => {
        if (data?.value && data?.value?.length) {
          this.increasedControlSystemCount = this.count;
          if (this.searchControlSystemTerm !== '') {this.increasedControlSystemCount = this.increasedControlSystemCount + this.count;}
          if (this.controlSystemList.length > 1) {
            if (data.value.length !== 0) {
              this.controlSystemList = this.mergeAndSortUniqueItem(this.controlSystemList, data.value, "control_system");
            } else {
              this.increasedControlSystemCount = 0;
              this.controlSystemLimitReached = data.value.length !== this.count;
              this.toastService.presentToast(this.translate.instant('no_control_system_records_available'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }
          } else {
            this.increasedControlSystemCount = 0;
            if (data.value.length !== 0) {
              this.controlSystemList = this.mergeAndSortUniqueItem(this.controlSystemList, data.value, "control_system");
            } else {
              this.increasedControlSystemCount = 0;
              this.controlSystemLimitReached = data.value.length !== this.count;
              this.toastService.presentToast(this.translate.instant('no_control_system_records_available'), 4000, AppConstants.ERROR_SNACKBAR, 'top');
            }
          }
          this.increasedControlSystemCount = this.increasedControlSystemCount + this.count;
        }
        setTimeout(() => {
        }, 500);
      }, err => {
      }
    );
  }

  fetchMoreControlSystem() {
    this.onControlSystemScrolled.emit();
  }

  setControlSystem(selectedItems) {
    if (selectedItems && selectedItems.length) {
      this.formData.controlSystem = selectedItems.map(item => 
        typeof item === 'object' ? item.id : item
      );
    } else {
      this.formData.controlSystem = [];
    }
  }

  async onSubmit(myForm: NgForm): Promise<void> {
    if (this.machineNameValidationInProgress) {
      return;
    }

    this.isFormSubmitted = true;
    if (this.isProjectAddCloneMode) {
      await this.proceedProjectCloneFromAdd(myForm);
      return;
    }
    if (this.isCloneMode) {
      await this.proceedClone(myForm);
      return;
    }
    if (myForm.invalid) {
      myForm.form.markAllAsTouched();
      this.toastService.presentToast(this.translate.instant('Required Fields Not Selected'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      return;
    } else {
      this.myFormValue = myForm.value;
      const machineName = (this.formData.machine_name || '').trim();
      const customerId = this.formData.customerId || this.each_service?.customer_id || this.each_service?.customer_Id;

      if (customerId && !this.formData.customerId) {
        this.formData.customerId = customerId;
        myForm.form.get('customerId')?.setValue(customerId);
      }

      if (myForm.value && machineName && customerId && this.formData.application && this.formData.machineType
        && this.formData.features.length && this.formData.controlSystem.length) {
        const isMachineNameValid = await this.validateMachineNameBeforeProceed(machineName, customerId, this.formData.customerName);

        if (!isMachineNameValid) {
          return;
        }

        this.formData.machine_name = machineName;
        myForm.form.get('machine_name')?.setValue(machineName);
        this.myFormValue = myForm.value;
        if (this.each_service == null && this.sharedValue.listOfServices.length == 0) {
          this.storeCreateMachineInfo(myForm.value);
        } else if (this.each_service?.page == 'projectDetails' && this.sharedValue.listOfServices.length == 0) {
          const machines = [];
          machines.push(myForm.value);
          if (machines.length > 0) {
            this.addNewMachine(machines);
          }
        } else if (this.each_service?.pageName === 'viewOffer' && this.sharedValue.viewOfferListOfServices.length) {
          //New Machine added to already existing service
          if (!this.each_service.hasOwnProperty('newService') && !this.each_service.newService) {
            this.sharedValue.viewOfferListOfServices.forEach(element => {
              if (this.each_service.service_id === element.service_id) {
                const machines = [];
                machines.push(myForm.value);
                if (machines.length > 0) {
                  this.addNewMachine(machines);
                }
                //Adding machine
                for (const each of this.sharedValue.viewOfferListOfServices) {
                  if (myForm.valid) {
                    if (each.service_id == this.each_service.service_id) {
                      each.machines = each.machines || [];
                      each.machines.push(myForm.value);
                      for (const machine of each.machines) {
                        if (machine.selectedMachinechecked) {
                          machine.selectedMachinechecked = false;
                        }
                      }
                      break;
                    }
                  } else {
                    myForm.form.markAllAsTouched();
                  }
                }
              }
            });
          }
        }
        else {
          if (this.sharedValue.listOfServices.length) {
            for (const each of this.sharedValue.listOfServices) {
              if (each.id == this.each_service.id) {
                each.machines = each.machines || [];
                each.machines.push(myForm.value);
                let machines = []
                machines.push(myForm.value)
                if (each.machines.length > 0) {
                  this.addNewMachine(machines);
                }
                for (const machine of each.machines) {
                  if (machine.selectedMachinechecked) {
                    machine.selectedMachinechecked = false;
                  }
                }
                break;
              }
            }
          }
        }
      } else {
        myForm.form.markAllAsTouched();
        this.toastService.presentToast(this.translate.instant('Required Fields Not Selected'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      }
    }
  }

  private async proceedClone(myForm: NgForm): Promise<void> {
    const machineName = (this.formData?.machine_name || '').trim();
    this.cloneSelectedCustomer = this.normalizeCloneCustomer(this.cloneSelectedCustomer);
    const customerId = this.isCustomerReadonly
      ? this.formData.customerId
      : this.getCloneCustomerId(this.cloneSelectedCustomer);
    const customerName = this.isCustomerReadonly
      ? (this.formData?.customerName || '').trim()
      : (this.getCloneCustomerName(this.cloneSelectedCustomer) || '').trim();
    if (!machineName || !customerId || !customerName) {
      myForm.form.markAllAsTouched();
      this.toastService.presentToast(this.translate.instant('Required Fields Not Selected'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      return;
    }

    const isMachineNameValid = await this.validateMachineNameBeforeProceed(machineName, customerId, customerName);
    if (!isMachineNameValid) {
      return;
    }

    this.formData.machine_name = machineName;
    this.formData.customerId = customerId;
    this.formData.customerName = customerName;

    this.modalCtrl.dismiss({
      cloneMachine: true,
      machineName,
      customerId,
      customerName,
      sourceMachine: this.cloneSourceMachine,
      sourceMachineId: this.getCloneSourceMachineId(),
      global_Id: this.cloneSourceMachine?.global_Id || this.cloneSourceMachine?.global_id || ''
    });
  }

  private async proceedProjectCloneFromAdd(myForm: NgForm): Promise<void> {
    const machineName = (this.formData?.machine_name || '').trim();
    const customerId = this.formData.customerId || this.each_service?.customer_id || this.each_service?.customer_Id;
    if (!this.selectedProjectCloneMachine || !machineName || !customerId) {
      myForm.form.markAllAsTouched();
      this.toastService.presentToast(this.translate.instant('Required Fields Not Selected'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
      return;
    }

    const isMachineNameValid = await this.validateMachineNameBeforeProceed(machineName, customerId, this.formData.customerName);
    if (!isMachineNameValid) {
      return;
    }

    this.dismissProjectCloneFromAdd(machineName, customerId);
  }

  private dismissProjectCloneFromAdd(machineName: string, customerId: any): void {
    this.modalCtrl.dismiss({
      cloneMachine: true,
      machineName,
      customerId,
      customerName: this.formData.customerName,
      sourceMachine: this.selectedProjectCloneMachine,
      sourceMachineId: this.getProjectMachineId(this.selectedProjectCloneMachine),
      global_Id: this.selectedProjectCloneMachine?.global_Id || this.selectedProjectCloneMachine?.global_id || ''
    });
  }

  private validateMachineNameBeforeProceed(machineName: string, customerId: any, customerName?: string): Promise<boolean> {
    if (!machineName || !customerId) {
      this.toastService.presentToast(
        this.translate.instant('Required Fields Not Selected'),
        4000,
        AppConstants.WARNING_SNACKBAR,
        'top'
      );
      return Promise.resolve(false);
    }

    this.machineNameValidationInProgress = true;
    // Backend returns the duplicate message as plain English text, not a translation
    // key, so instant() on it would just echo it back untranslated. Build our own
    // localized copy instead, matching the backend's wording via interpolation.
    const duplicateMachineMessage = this.translate.instant('machine_already_exists_for_customer', {
      machineName,
      customerName: customerName || ''
    });

    return new Promise((resolve) => {
      this.backendService.validateMachineName({ machineName, customerId }).pipe(
        finalize(() => {
          this.machineNameValidationInProgress = false;
        })
      ).subscribe({
        next: (response: any) => {
          const isDuplicate = response?.response?.isExists === true || response?.statusCode === 409;

          if (isDuplicate) {
            this.toastService.presentToast(
              duplicateMachineMessage,
              4000,
              AppConstants.ERROR_SNACKBAR,
              'top'
            );
            resolve(false);
            return;
          }

          if (response?.flag === false || (response?.statusCode && response.statusCode >= 400)) {
            this.toastService.presentToast(
              this.translate.instant('something_went_wrong'),
              4000,
              AppConstants.ERROR_SNACKBAR,
              'top'
            );
            resolve(false);
            return;
          }

          resolve(response?.response?.isExists !== true);
        },
        error: (error: any) => {
          const errorResponse = error?.error || {};
          const isDuplicate = error?.status === 409 || errorResponse?.response?.isExists === true;

          this.toastService.presentToast(
            isDuplicate
              ? duplicateMachineMessage
              : this.translate.instant('something_went_wrong'),
            4000,
            AppConstants.ERROR_SNACKBAR,
            'top'
          );
          resolve(false);
        }
      });
    });
  }
  /**
   * Add new machines
   *
   * @param machines
   */
  addNewMachine(machines) {
    const machinesArray = [];
    machines.forEach((each_machine) => {
      const data = {
        id: '',
        machine_name: each_machine?.machine_name,
        service_id: this.each_service.service_id || this.each_service.service_Id,
        customer_Id: this.each_service.customer_id || this.formData?.customerId,
        asset_id: each_machine?.asset_id,
        machine_type: each_machine?.machine_type,
        industry_type: '',
        master_machine_id: '',
        serial_number: each_machine?.serial_number,
        serviceMachine_Id: '',
        machine_description: each_machine?.machine_description,
        estimated_hours: each_machine?.estimatedHours,
        created_at: new Date().toISOString(),
        created_by: '',
        modified_at: new Date().toISOString(),
        modified_by: '',
        machine_location: '',
        erp_wbs_id: '',
        manufacturer: each_machine?.manufacturer,
        model_Number: each_machine?.model,
        machineModes: this.selectedMachineMode.map(mode => mode.id),
        machineMetadata: [
          {
            application: this.formData.application,
            machineType: this.formData.machineType,
            specificFeature: this.formData.features,
            controlSystem: this.formData.controlSystem
          }
        ]
      };
      machinesArray.push(data);
    });
    this.backendService.addNewMachines(machinesArray).subscribe((data: any) => {
      if (data.statusCode == 200
        && Array.isArray(JSON.parse(data.response))
        && JSON.parse(data.response).length > 0) {
        if((this.each_service?.page == 'projectDetails'
        ||this.each_service?.pageName == 'viewOffer'
        ||this.each_service?.pageName == 'ProjectAction' 
        ||this.each_service?.pageName == 'createOffer')) {
          const response = JSON.parse(data.response);
          machines.forEach((machine: any) => {
            response?.filter((item: any) => item.MachineName == machine.machine_name).map((ele: any) => {
              machine.machine_Name = ele.MachineName;
              machine.global_Id = ele.GlobalId;
              // While adding the machine from create-offer we need to set Id as well, further it will use to bind with service
              machine.id = ele.Id;
              machine.customer_Id = ele.CustomerId;
              machine.machine_type = ele.MachineType;
            });
          });
        }
        const APIPayload = {
          project_Id: this.each_service.project_id ? this.each_service.project_id : this.each_service.project_Id,
          order_Id: this.each_service.order_id ? this.each_service.order_id : this.each_service.order_Id,
          service_Id: this.each_service.service_id ? this.each_service.service_id : this.each_service.service_Id
        };
        document.dispatchEvent(new CustomEvent('APICallMachineList', { detail: APIPayload }));
        this.toastService.presentToast(this.translate.instant('Machines Added Successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
        const parsed = JSON.parse(data?.response) || [];
        const transformed = parsed.map((item: any) => ({
          machine_Name: item.MachineName,
          customer_Id: item.CustomerId,
          global_Id: item.GlobalId,
          id: item.Id,
          machine_type: item.MachineType
        }));
        this.modalCtrl.dismiss({
          machine: transformed[0],
          dismissed: true,
        });
      } else {
        this.handleAddMachineError(data.message);
      }
    }, err => {
       this.handleAddMachineError(err.error?.message || 'Unknown error occurred');
    });
  }

  private handleAddMachineError(message: string) {
    this.toastService.presentToast(message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
    if (
      this.each_service?.page !== 'projectDetails' &&
      this.each_service?.pageName !== 'viewOffer' &&
      this.sharedValue.listOfServices?.length
    ) {
      this.sharedValue.listOfServices.forEach((each) => {
        if (each.id === this.each_service.id && Array.isArray(each.machines)) {
          each.machines = each.machines.filter(
            (machine: any) => {
              const sameName = machine.machine_Name === this.formData.machine_Name;
              const hasId = !!machine.id;
              // Keep if name is different, or if it has an ID
              return !sameName || hasId;
            }
          );
        }
      });
    }
    this.modalCtrl.dismiss({
      dismissed: true,
      error: message
    });
  }

  noSubmit(e) {
    e.preventDefault();
  }

  customerSearchByErpId(customer) {
    this.getCustomerAndSegment(customer).subscribe((responses: any) => {
      if (responses && responses.length) {
        const customerInfo = responses[0];
        const segmentInfo = responses[1].result;
        customerInfo.contacts.map((i) => { i.fullName = (i.first_Name != null ? i.first_Name : '') + ' ' + (i.last_Name != null ? i.last_Name : ''); return i; });
        this.sharedValue.customersInfo.next(customerInfo);
        this.formData.customerId = customerInfo?.customer_Id;
        this.formData.customerName = customerInfo?.customer_Name;
        this.formData.industrySegment = segmentInfo[0]?.segment;
      }
    }, err => {
      this.toastService.presentToast(this.translate.instant('no_results_found'), 4000, AppConstants.ERROR_SNACKBAR, 'top');   
    });
  }

  // To get the industryCode as per the customerId
  getCustomerAndSegment(cust) {
    const getCustomer = this.backendService.offerCustomerInfoSearchByErpId(cust.erp_customer_id);
    const getSegment = this.backendService.getSegments(cust.erp_customer_id);
    return forkJoin([getCustomer, getSegment]);
  }

  // To prepare the payload for creating a machine
  private async storeCreateMachineInfo(data) {
    const payload = [];
    const machine = {
      id: '',
      machine_name: data.machine_name,
      service_id: '',
      customer_Id: data.customerId,
      asset_id: data.asset_id,
      machine_type: data.machineType,
      industry_type: '',
      master_machine_id: '',
      serial_number: data.serial_number,
      serviceMachine_Id: '',
      estimated_hours: 0,
      created_at: new Date().toISOString(),
      created_by: '',
      modified_at: new Date().toISOString(),
      modified_by: '',
      machine_location: '',
      erp_wbs_id: '',
      machineModes: this.selectedMachineMode.map(mode => mode.id),
      machineMetadata: [
        {
          application: this.formData.application,
          machineType: this.formData.machineType,
          specificFeature: this.formData.features,
          controlSystem: this.formData.controlSystem
        }
      ]
    };
    payload.push(machine);
    this.backendService.addNewMachines(payload).subscribe(
      async (data: any) => {
        if (
          data.statusCode === 200 &&
          Array.isArray(JSON.parse(data.response)) &&
          JSON.parse(data.response).length > 0
        ) {
          const response = JSON.parse(data.response);
          const createdMachine = response[0];
          this.toastService.presentToast(this.translate.instant('Machines Added Successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
          await this.router.navigate(
            ['/machine-management/machine-info', createdMachine?.Id],
            {
              queryParams: {
                machineName: createdMachine?.MachineName,
                global_Id: createdMachine?.GlobalId,
                source: 'machine',
                isEditMachineShow: true
              },
              queryParamsHandling: 'merge'
            }
          );
          this.modalCtrl.dismiss();
        } else {
          this.toastService.presentToast(data?.message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
        }
      },
      (err) => {
        this.toastService.presentToast(data?.message, 4000, AppConstants.ERROR_SNACKBAR, 'top');
      }
    );
  }

  async presentLoading(msg) {
    const loading = await this.loading.create({
      cssClass: 'my-custom-loading',
      message: msg,
      spinner: 'bubbles'
    });
    await loading.present();
    return loading;
  }

  closeModal(): void {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }
}
